import { useRef } from 'react';
import cn from 'classnames';

import Button from '@components/Button';
import Title from '@components/Title';
import { PlusIcon } from '@components/Icon';

import s from './Accordion.module.scss';

export interface ExternalAccordionItemProps {
  heading: string;
}

interface InternalAccordionItemProps extends ExternalAccordionItemProps {
  index: number;
  isActive: boolean;
  setActiveIndex(index: number): void;
}

export const AccordionItem: React.FC<InternalAccordionItemProps> = ({
  index,
  isActive,
  setActiveIndex,
  heading,
  children,
}) => {
  const rootClass = cn(s.accordionSection, isActive && s.active);

  const contentRef = useRef(null);

  const contentClass = cn(s.accordionSection__content, isActive && s.active);

  return (
    <div className={rootClass}>
      <Button theme="ghost" onClick={() => setActiveIndex(index)} className={s.button}>
        <Title level={4} className={s.title}>
          {heading}
        </Title>

        <span className={s.icon}>
          <PlusIcon />
        </span>
      </Button>

      <div className={contentClass} ref={contentRef}>
        {isActive ? children : null}
      </div>
    </div>
  );
};
